// Цеха рядом, столбец на каждый.
//
// Директору одного цеха этот экран не нужен: у него всё и так на дашборде. Он
// нужен тому, у кого цехов несколько, и вопрос у него ровно один — ГДЕ ХУЖЕ.
//
// Пока сравнивать приходилось переключением туда-сюда и памятью, сравнения не
// было вовсе: две цифры, увиденные с промежутком в минуту, человек
// сопоставляет плохо. Здесь они стоят рядом, и худшая подсвечена — не потому
// что она красная сама по себе, а потому что она худшая ИЗ ЭТИХ.
import React, { useState, useEffect, useCallback } from 'react';
import { compareAPI } from '../api';

const TH = {
  padding: '9px 12px', textAlign: 'left', fontSize: 11.5, fontWeight: 700,
  color: 'var(--dim)', textTransform: 'uppercase', whiteSpace: 'nowrap',
  borderBottom: '1px solid var(--border)',
};
const TD = {
  padding: '10px 12px', fontSize: 14, color: 'var(--text)',
  borderBottom: '1px solid var(--border)', whiteSpace: 'nowrap',
};

// Столбцы. `worse` говорит, в какую сторону плохо: у брака больше — хуже, у
// выполнения плана наоборот. Без этого подсветка врала бы ровно наполовину.
const COLS = [
  { key: 'produced',    title: 'Выпущено',      unit: 'шт' },
  { key: 'plan_rate',   title: 'План',          unit: '%',  worse: 'less' },
  { key: 'shifts',      title: 'Смен',          unit: '' },
  { key: 'sheets',      title: 'Принято',       unit: 'шт' },
  { key: 'defect_rate', title: 'Некондиция',    unit: '%',  worse: 'more' },
  { key: 'orders_open', title: 'Заказов в работе', unit: '' },
];

export default function BranchCompare({ days = 7 }) {
  const [data, setData] = useState(null);

  const load = useCallback(() => {
    compareAPI.branches({ days })
      .then(r => setData(r.data))
      .catch(() => setData({ branches: [] }));
  }, [days]);
  useEffect(() => { load(); }, [load]);

  if (!data) {
    return <div style={{ color: 'var(--muted)', padding: 20 }}>Загрузка…</div>;
  }
  const rows = data.branches || [];
  if (rows.length < 2) {
    return (
      <div style={{ color: 'var(--dim)', padding: 20, fontSize: 13 }}>
        Цех один — сравнивать не с чем. Раздел появится, когда откроется второй.
      </div>
    );
  }

  // Худшее значение в каждом столбце — чтобы подсветить именно его.
  const worst = {};
  COLS.forEach(c => {
    if (!c.worse) return;
    const vals = rows.map(r => r[c.key]).filter(v => v !== null && v !== undefined);
    if (!vals.length) return;
    worst[c.key] = c.worse === 'more' ? Math.max(...vals) : Math.min(...vals);
  });

  const cell = (r, c) => {
    const v = r[c.key];
    if (v === null || v === undefined) return <span style={{ color: 'var(--dim)' }}>—</span>;
    const bad = worst[c.key] !== undefined && v === worst[c.key]
      && rows.length > 1;
    return (
      <span style={{ color: bad ? '#ef4444' : 'var(--text)',
                     fontWeight: bad ? 800 : 600 }}>
        {v}{c.unit ? ' ' + c.unit : ''}
      </span>
    );
  };

  const t = data.total || {};

  return (
    <div>
      <div style={{ color: 'var(--muted)', fontSize: 12.5, marginBottom: 12,
                    lineHeight: 1.6, maxWidth: 720 }}>
        Одни и те же цифры по каждому цеху, за {data.days} дн. Красным — худший
        из цехов по этому столбцу; это сравнение между собой, а не с нормой.
      </div>

      <div style={{ background: 'var(--card)', borderRadius: 12, overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 720 }}>
          <thead>
            <tr>
              <th style={TH}>Цех</th>
              {COLS.map(c => <th key={c.key} style={{ ...TH, textAlign: 'right' }}>{c.title}</th>)}
            </tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id}>
                <td style={TD}>
                  <div style={{ fontWeight: 700 }}>{r.name}</div>
                  {r.city && (
                    <div style={{ fontSize: 11, color: 'var(--dim)' }}>{r.city}</div>
                  )}
                </td>
                {COLS.map(c => (
                  <td key={c.key} style={{ ...TD, textAlign: 'right' }}>{cell(r, c)}</td>
                ))}
              </tr>
            ))}
            {/* Итог считает сервер: складывать проценты нельзя, средний брак по
                заводу — это брак всех цехов делить на листы всех цехов */}
            <tr style={{ background: 'var(--bg)' }}>
              <td style={{ ...TD, fontWeight: 800 }}>Всего</td>
              {COLS.map(c => (
                <td key={c.key} style={{ ...TD, textAlign: 'right', fontWeight: 800 }}>
                  {t[c.key] === null || t[c.key] === undefined
                    ? '—' : `${t[c.key]}${c.unit ? ' ' + c.unit : ''}`}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
